import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SettingsSiteState } from '../../types/store-types/settings-types'
import { ISettings } from '../../types/services-types/admin-types'



const initialState: SettingsSiteState = {
  settings: null
}



const settingsSiteSlice = createSlice({
  name: 'settingsSite',
  initialState,
  reducers: {
    setSettings: (state, action: PayloadAction<ISettings>) => {
        state.settings = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const {setSettings } = settingsSiteSlice.actions

export default settingsSiteSlice.reducer